export default __webpack_public_path__ + "static/media/marketplace3.3e800d6b.jpg";